// @flow strict

import { useEffect, useState } from 'react';
import { retrieveUserProfile, userSubscriptionInfo } from '../api/profile';
import { getUserID } from '../Utility/service';

function useRemaining() {
  const [activePlan, setActivePlan] = useState(null);
  const [remaining, setRemaining] = useState(null);
  const [expireDate, setExpireDate] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const userId = getUserID();
  const [userInfo, setUserInfo] = useState({});

  useEffect(() => {
    retrieveUserProfile(userId).then((user) => {
      setUserInfo(user);
    });
  }, [userId]);

  const getInfo = async () => {
    setIsLoading(true);
    try {
      const res = await userSubscriptionInfo();
      setSubscription(res?.subscription);
      setExpireDate(res?.expireDate);
      setActivePlan(res?.activePlan);
      setRemaining(res?.remaining);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    };
  };

  useEffect(() => {
    getInfo();
  }, []);

  return {
    activePlan,
    remaining,
    expireDate,
    subscription,
    userInfo,
    isLoading,
  };
};

export default useRemaining;